import { render, staticRenderFns } from "./DocsHeaderButton.vue?vue&type=template&id=398a3950&"
import script from "./DocsHeaderButton.vue?vue&type=script&lang=js&"
export * from "./DocsHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports